import { UpdateFinancialAccountInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const mutationFinancialAccountUpdateAtom = createMutationAtomFactory(
  'finance.financialAccountUpdate',
  (params: { id: string } & UpdateFinancialAccountInput) => ({
    financeFinancialAccountUpdate: {
      __args: {
        id: params.id,
        input: { ...params, id: undefined },
      },
      __scalar: true,
      name: true,
      type: true,
      currentBalance: {
        __scalar: true,
      },
      currency: true,
      visibleInPayments: true,
      roundingMethod: true,
      roundingPrecision: true,
      nachaCompanyIdentification: true,
      nachaCompanyName: true,
      nachaDefaultSecCode: true,
      timestamps: {
        __scalar: true,
      },
    },
  }),
);
